module.exports = __webpack_public_path__ + "img/galerie-24.f7be65b9.jpg";